import './index.less';
import * as React from 'react';
// @ts-ignore
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import classnames from 'classnames';

interface LightBoxProps {
  isOpen: boolean;
  images: any[];
  photoIndex: number;
  handleClose: Function;
  handleOperateRequest: Function;
  className?: string;
}

class LightBox extends React.Component<LightBoxProps, any> {

  constructor(props: LightBoxProps) {
    super(props);
  }

  private toolbarButtons = [
    <a key="cur-pic-url" className="cur-pic-url" onClick={() => this.handlePicOriginal()}>原图</a>,
  ];

  private getWindowHeight = () => {
    return 'undefined' === typeof window ? 0 :
      window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  }

  private getWindowWidth = () => {
    return 'undefined' === typeof window ? 0 :
      window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  }

  private handlePicOriginal = () => {
    const { images, photoIndex } = this.props;
    const PADDING = 20; // According to Lightbox default options
    const RATIO = 1.007; // According to Lightbox default options
    const docW = this.getWindowWidth();
    const docH = this.getWindowHeight();
    // @ts-ignore
    const imageCache = this.lb.imageCache;
    const image = imageCache[images[photoIndex].url];
    const width = image.width;
    const height = image.height;
    const maxWidth = Math.min(docW - PADDING, width);
    const maxHeight = Math.min(docH - PADDING, height);
    const flag = maxWidth / maxHeight > width / height;
    const targetWidth = flag ? width * maxHeight / height : maxWidth;
    const offsetX = 0;
    const offsetY = 0;
    const zoomLevel = Math.log(width / targetWidth) / Math.log(RATIO);
    // @ts-ignore
    this.lb.setState({ offsetX, offsetY, zoomLevel });
  }

  public render() {
    const { isOpen, images, photoIndex, handleClose, handleOperateRequest, className } = this.props;
    const classes = classnames(className, {
      [`${className}`]: !!className,
      'beehive-light-box': true,
      'dis-left': photoIndex === 0,
      'dis-right': photoIndex === images.length - 1,
    });
    return (
      isOpen ? (
        <Lightbox
          wrapperClassName={classes}
          mainSrc={images[photoIndex].url}
          toolbarButtons={this.toolbarButtons}
          imageCaption={images[photoIndex].name}
          nextSrc={images[(photoIndex + 1) % images.length].url}
          prevSrc={images[(photoIndex + images.length - 1) % images.length].url}
          onCloseRequest={() => handleClose()}
          onMovePrevRequest={() => {
            return photoIndex !== 0 ? handleOperateRequest(photoIndex, images.length, true) : false;
          }}
          onMoveNextRequest={() => {
            return photoIndex !== images.length - 1 ? handleOperateRequest(photoIndex, images.length, false) : false;
          }}
          // @ts-ignore
          ref={(el) => this.lb = el}
        />
      ) : <div />
    );
  }
}

export default LightBox;
